import React from 'react';
import { Container, CommomTitle, ImagesContainer, Image, CommomCentred, BannerCenterActions, BannerTitle, ColorLink  } from './styled';

import Button from "components/Button";
import { useHistory } from 'react-router-dom';

// Caminhos das imagens (substitua com os caminhos corretos)
const image1 = '/images/salomao_pixel.png';
const image2 = '/images/davi_pixel.png';
const image3 = '/images/ester_pixel.png';
const image4 = '/images/daniel_pixel.png';
//const image5 = '/images/stonel_pq_assinar_atvidades_smilinguido.png';

const ResponsiveImagesSection = () => {

    const history = useHistory();
    const navigate = to => history.push(`/${ to }`);
    
  return (
    <Container>
      {/* Título */}
      <CommomTitle>Com quem você vai conversar?</CommomTitle>
      <p style={{ color: '#aaaaaa', textAlign: 'center', marginBottom: '10px', fontSize: '16px' }}>
        Quatro personalidades. Quatro estilos de sabedoria. Escolha por onde começar.
      </p>

      {/* Container das Imagens */}
      <ImagesContainer>
        <Image src={image1} alt="Rei Salomão" />
        <Image src={image2} alt="Rei Davi" />
        <Image src={image3} alt="Rainha Ester" />
        <Image src={image4} alt="Profeta Daniel" />
      </ImagesContainer>

      <BannerCenterActions>
        <Button green onClick={() => navigate('register?plan=free')}>Começar grátis</Button>
        <BannerTitle><a href="https://wa.me/5516982026554?text=Eu%20quero%20saber%20mais%20sobre%20o%20TiqChat!"><ColorLink><Button white>Falar no WhatsApp</Button></ColorLink></a></BannerTitle>
      </BannerCenterActions>

    </Container>
  );
};

export default ResponsiveImagesSection;

//<Youtube videoId={`dUxUDhSRd8M`} key={`dUxUDhSRd8M`}/>
// na linha 32 <Player autoplay={true}>